import React from 'react'
import { Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ItemDetails } from 'components'
import { useIsSmallScreen } from 'packages/core'
import { CommonAttributes } from '../CommonAttributes'
import InfoBoxWithIcon from 'components/common/InfoBoxWithIcon'
import DomPurify from 'dompurify'
import ReactHtmlParser from 'react-html-parser'
const overflowStyleProps = {
    maxHeight: '220px',
    overflow: 'auto',
}

const PaddedDiv = styled(Box)({
    padding: '0 31px',
})

export const OverviewSection = ({ applicationRole }: any) => {
    const { t } = useTranslation()

    const attributeOrientation = useIsSmallScreen() ? 'vertical' : 'horizontal'
    const parsedHtml = ReactHtmlParser(
        DomPurify.sanitize(applicationRole?.instructions),
    )
    return (
        <ItemDetails.AttributesContainer
            data-ai-explain="Application role overview: read-only fields for technical name, resource system, optional process and differentiation, classification, description, common policy attributes, and any published instructions."
        >
            <PaddedDiv>
                <ItemDetails.Attribute
                    label={t('Common_TechnicalName')}
                    value={applicationRole.name}
                    orientation={attributeOrientation}
                    valueProps={overflowStyleProps}
                />
                <ItemDetails.Attribute
                    label={t('ApplicationRoles_ResourceSystem')}
                    value={applicationRole.resourceSystemFriendlyName}
                    orientation={attributeOrientation}
                    valueProps={overflowStyleProps}
                />

                {applicationRole.applicationProcess_FriendlyName && (
                    <ItemDetails.Attribute
                        label={t('ApplicationRoles_Process')}
                        value={applicationRole.applicationProcess_FriendlyName}
                        orientation={attributeOrientation}
                        valueProps={overflowStyleProps}
                    />
                )}
                {applicationRole.differentiationValue_FriendlyName && (
                    <ItemDetails.Attribute
                        label={t('ApplicationRoles_DifferentiationValue')}
                        value={
                            applicationRole.differentiationValue_FriendlyName
                        }
                        orientation={attributeOrientation}
                        valueProps={overflowStyleProps}
                    />
                )}

                <ItemDetails.Attribute
                    label={t('ApplicationRoles_HighLevelClassification')}
                    value={applicationRole.highLevelClassification}
                    orientation={attributeOrientation}
                    valueProps={overflowStyleProps}
                />
                <ItemDetails.Attribute
                    label={t('Common_Description')}
                    value={applicationRole.description}
                    orientation={attributeOrientation}
                    valueProps={overflowStyleProps}
                />
                <CommonAttributes resource={applicationRole} />

                {parsedHtml && parsedHtml.length > 0 && (
                    <InfoBoxWithIcon
                        iconName={'InfoNew'}
                        message={parsedHtml}
                        rootStyles={{
                            width: '100%',
                            marginTop: '2.8rem',
                            marginBottom: '1.8rem',
                        }}
                    />
                )}
            </PaddedDiv>
        </ItemDetails.AttributesContainer>
    )
}
